export default "__VITE_ASSET__BrcGHuGR__"